// @ts-nocheck
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import constants from "@store/constants";
import { StoreAccountParameter } from "@store/Framework/Store/Store/Data/Accounts/Handlers/CreateAccountStore";
import { StoreAccountModel } from "@store/Framework/Types/ApiModels";

const storeAccountsUrl = "/api/v1/custom/users";

export interface StoreAccountApiParameter extends StoreAccountParameter {}

export async function createAccount(parameter: StoreAccountApiParameter): Promise<ServiceResult<StoreAccountModel>> {
    try {
        const accountModel = await post<StoreAccountModel>(`${storeAccountsUrl}`, parameter);
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if (constants.apiCode.status in error && error.status === 400 && error.errorJson && error.errorJson.errors) {
            return {
                successful: false,
                errorMessage: error.errorJson.errors[0].message,
            };
        }
        throw error;
    }
}
